
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fr/for-medical-doctors",
      function () {
        return require("private-next-pages/fr/for-medical-doctors/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fr/for-medical-doctors"])
      });
    }
  